import { render, staticRenderFns } from "./OneTimeTransfer.vue?vue&type=template&id=345a159e&scoped=true"
import script from "./OneTimeTransfer.vue?vue&type=script&lang=js"
export * from "./OneTimeTransfer.vue?vue&type=script&lang=js"
import style0 from "./OneTimeTransfer.vue?vue&type=style&index=0&id=345a159e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345a159e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VContainer,VForm,VIcon,VSelect,VTextField})
